export enum CampaignType {
  reviewRewardCampaign = 'reviewRewardCampaign',
  limitedTimePurchaseRewardCampaign = 'limitedTimePurchaseRewardCampaign',
  purchaseRewardCampaign = 'purchaseRewardCampaign',
  contentRewardCampaign = 'contentRewardCampaign',
  referralRewardCampaign = 'referralRewardCampaign',
  /**
   * Now called as Membership Reward Campaign
   */
  promoteBrandClubRewardCampaign = 'promoteBrandClubRewardCampaign',
  affiliateLinkCampaign = 'affiliateLinkCampaign',
  socialRewardCampaign = 'socialRewardCampaign',
  surveyRewardCampaign = 'surveyRewardCampaign',
  retailerConnectRewardCampaign = 'retailerConnectRewardCampaign',
  pageScanRewardCampaign = 'pageScanRewardCampaign',
  /**
   * new reward type issued as locked reward (for people belonging to an audience criteria) and unlocked by sync action
   */
  syncRewardCampaign = 'syncRewardCampaign',

  //// Messaging Campaign types:
  messagingCampaign = 'messagingCampaign', // Old type of messagingCampaign
  orderReceiptMessagingCampaign = 'orderReceiptMessagingCampaign',
  postPurchaseConnectMessagingCampaign = 'postPurchaseConnectMessagingCampaign',
  reviewRequestMessagingCampaign = 'reviewRequestMessagingCampaign',
  membershipRewardReceiptMessagingCampaign = 'membershipRewardReceiptMessagingCampaign',
  surveyRewardReceiptMessagingCampaign = 'surveyRewardReceiptMessagingCampaign',
  affiliateRewardReceiptMessagingCampaign = 'affiliateRewardReceiptMessagingCampaign',
  contentRewardReceiptMessagingCampaign = 'contentRewardReceiptMessagingCampaign',
  reviewRewardReceiptMessagingCampaign = 'reviewRewardReceiptMessagingCampaign',
  expiringRewardReminderMessagingCampaign = 'expiringRewardReminderMessagingCampaign',
  reorderRequestMessagingCampaign = 'reorderRequestMessagingCampaign',
  productRecommendationsMessagingCampaign = 'productRecommendationsMessagingCampaign',
  rewardRecommendationsMessagingCampaign = 'rewardRecommendationsMessagingCampaign',
}

export enum MessagingCampaignType {
  messagingCampaign = 'messagingCampaign', // Old type of messagingCampaign
  orderReceiptMessagingCampaign = 'orderReceiptMessagingCampaign',
  postPurchaseConnectMessagingCampaign = 'postPurchaseConnectMessagingCampaign',
  reviewRequestMessagingCampaign = 'reviewRequestMessagingCampaign',
  membershipRewardReceiptMessagingCampaign = 'membershipRewardReceiptMessagingCampaign',
  surveyRewardReceiptMessagingCampaign = 'surveyRewardReceiptMessagingCampaign',
  affiliateRewardReceiptMessagingCampaign = 'affiliateRewardReceiptMessagingCampaign',
  contentRewardReceiptMessagingCampaign = 'contentRewardReceiptMessagingCampaign',
  reviewRewardReceiptMessagingCampaign = 'reviewRewardReceiptMessagingCampaign',
  expiringRewardReminderMessagingCampaign = 'expiringRewardReminderMessagingCampaign',
  reorderRequestMessagingCampaign = 'reorderRequestMessagingCampaign',
  productRecommendationsMessagingCampaign = 'productRecommendationsMessagingCampaign',
  rewardRecommendationsMessagingCampaign = 'rewardRecommendationsMessagingCampaign',
}

// See CAMPAIGN_DISPLAY in the web app
export const getCampaignTypeDisplayName = (campaignType: CampaignType): string => {
  switch (campaignType) {
    case CampaignType.purchaseRewardCampaign:
      return 'Purchase Reward Campaign';
    case CampaignType.limitedTimePurchaseRewardCampaign:
      return 'Daily Deal Reward Campaign';
    case CampaignType.reviewRewardCampaign:
      return 'Rating Campaign';
    case CampaignType.referralRewardCampaign:
      return 'Referral Reward Campaign';
    case CampaignType.promoteBrandClubRewardCampaign:
      return 'Membership Reward Campaign';
    case CampaignType.surveyRewardCampaign:
      return 'Survey Reward Campaign';
    case CampaignType.contentRewardCampaign:
      return 'Content Reward Campaign';
    case CampaignType.retailerConnectRewardCampaign:
      return 'Connect Reward Campaign';
    case CampaignType.affiliateLinkCampaign:
      return 'Affiliate Reward Campaign';
    case CampaignType.syncRewardCampaign:
      return 'Sync Reward Campaign';
  }
  return campaignType;
};
